import { Resource, Workspace } from '@app-types/blackroom-api';

export const getWorkspaceURL = (workspace: Pick<Workspace, 'id'>) => {
  const baseURL =
    import.meta.env.NODE_ENV === 'production'
      ? import.meta.env.VITE_APP_URL
      : window.origin;
  return `${baseURL}/workspace/${workspace.id}`;
};

export const getResourceURL = (
  resource: Pick<Resource, 'id' | 'type'>,
  workspace: Pick<Workspace, 'id'>,
) => `${getWorkspaceURL(workspace)}/${resource.type}/${resource.id}`;
